const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export function skipAuth(): HttpContext {
	return new HttpContext().set(SKIP_AUTH, true);
}

import { Injectable } from "@angular/core";
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpContextToken,
	HttpContext
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "@core/services/auth/auth.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		const token = this.authService.getToken()
			? this.authService.getToken()
			: this.authService.getTokenSupportAccountant();

		if (token && !request.context.get(SKIP_AUTH)) {
			return next.handle(
				request.clone({
					headers: request.headers.set(
						"Authorization",
						"Bearer " + token
					)
				})
			);
		}
		return next.handle(request);
	}
}
